<template>
  <layout :title-text="title">
    <div slot="content" class="notice-container">
      <div class="notice-content">
        <div :class="item.className" v-for="(item, index) in pdfList" :key="index">
          <a :href="item.imgUrl" target="_blank"><img :src="item.btnPath" draggable="false"></a>
        </div>
        <div class="notice-pdf4">
          <div class="notice-new">
            <div v-for="(item, index) in noticeList" :key="index" class="notice-scroll">
              <a :href="item.pdf_addr" target="_blank">
                <span class="title">{{ item.title }}</span>
              </a>
              <span class="times"><em>{{ item.date }}</em></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
import { getHomeData } from '../../network/home'
import btnView from '../../assets/images/btn_view_now.png'

export default {
  components: {
    Layout
  },
  data () {
    return {
      title: '赛事公告',
      noticeList: [],
      pdfList: [
        {
          className: 'notice-pdf-left',
          imgUrl: 'https://shs3.b.qianxin.com/qax-cms/6f3ab98ff3cc98a4a7faa0dbb9500e39.pdf',
          btnPath: btnView
        },
        {
          className: 'notice-pdf-center',
          imgUrl: 'https://shs3.b.qianxin.com/qax-cms/7aee284734624f8872d65f8aa65c2f2d.pdf',
          btnPath: btnView
        },
        {
          className: 'notice-pdf-right',
          imgUrl: 'https://shs3.b.qianxin.com/qax-cms/acfa8f998a299844c43e881f3400cd2e.pdf',
          btnPath: btnView
        }
      ]
    }
  },
  created () {
    getHomeData().then(res => {
      if (res.data.code === '200') {
        this.noticeList = res.data.data
        // console.log(this.noticeList)
      }
    })
  }
}
</script>

<style lang="less" scoped>
.notice-container {
  background: url(../../assets/images/bg_match_notice.png) no-repeat;
  background-size: 100% 100%;
  height: 420px;
  .notice-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1150px;
    height: 420px;
    margin: 0 auto;
    > div:not(:last-child){
      position: relative;
      height: 373px;
      width: 260px;
      img {
        position: absolute;
        bottom: 90px;
        left: 25%;
        cursor: pointer;
      }
    }
  }
  .notice-pdf-left {
    background: url(../../assets/images/img_match-notice1.png) no-repeat;
    background-size: 100% 100%;
  }
  .notice-pdf-center {
    background: url(../../assets/images/img_match-notice2.png) no-repeat;
    background-size: 100% 100%;
  }
  .notice-pdf-right {
    background: url(../../assets/images/img_match-notice3.png) no-repeat;
    background-size: 100% 100%;
  }
  .notice-pdf4 {
    position: relative;
    padding: 16px 4px 16px 20px;
    box-sizing:border-box;
    background-color: #243074;
    text-align: left;
    height: 373px;
    width: 254px;
    .notice-scroll {
      border-bottom: 1px dotted rgba(181, 185, 228, .6);
      padding-bottom: 8px;
    }
    .notice-new {
      height: 100%;
      width: 100%;
      overflow: auto;
      a {
        display: block;
        color: #B5B9E4;
        margin-bottom: 8px;
      }
      .title {
        display: block;
        font-size: 14px;
        font-weight: 400;
        line-height: 24px;
        color: white;
      }
      .times {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 24px;
        opacity: 0.5;
      }
    }
    .notice-new::-webkit-scrollbar {
        /*滚动条整体样式*/
        width : 5px;  /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
    }
    .notice-new::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius   : 10px;
        background-color: #A7C2FF;
        background-image: -webkit-linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.2) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.2) 50%,
            rgba(255, 255, 255, 0.2) 75%,
            transparent 75%,
            transparent
        )
    }
    .notice-new::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
        background   : #1A2892;
        border-radius: 10px;
    }
  }
}
</style>
